export default __webpack_public_path__ + "static/media/teste-perfil.8ba76b81.jpg";